/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Carrier_Review_Before_ApplyInputs */

const en_orders_carrier_review_before_apply = /** @type {(inputs: Orders_Carrier_Review_Before_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the carrier update before applying it.`)
};

const es_orders_carrier_review_before_apply = /** @type {(inputs: Orders_Carrier_Review_Before_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa la actualizacion del transportista antes de aplicarla.`)
};

/**
* | output |
* | --- |
* | "Review the carrier update before applying it." |
*
* @param {Orders_Carrier_Review_Before_ApplyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_review_before_apply = /** @type {((inputs?: Orders_Carrier_Review_Before_ApplyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Review_Before_ApplyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_review_before_apply(inputs)
	return es_orders_carrier_review_before_apply(inputs)
});